import Vue from 'vue'

const scales = { small: 0.85, standard: 1, large: 1.15, extraLarge: 1.3 }
export const appFont = Vue.observable({ scale: 1 })

// Keep the preference only for this WebView session, never in persistent storage.
export function installAppFont(router) {
  router.beforeEach((to, from, next) => {
    if (Object.prototype.hasOwnProperty.call(to.query, 'appFontSize')) {
      const value = to.query.appFontSize
      appFont.scale = typeof value === 'string' && Object.prototype.hasOwnProperty.call(scales, value) ? scales[value] : 1
    }
    document.documentElement.classList.toggle('app-font-enlarged', appFont.scale > 1)
    document.documentElement.style.setProperty('--app-font-scale', appFont.scale)
    next()
  })
}
